
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  computed: {
    broadcastDetails () {
      if (!this.fixture?.fixtureBroadcasts?.length) return null;
      const broadcastDetails = [];
      for (const broadcaster of this.fixture?.fixtureBroadcasts) {
        broadcastDetails.push({
          link: this.getFixtureBroadcastLink(broadcaster),
          img: this.getFixtureBroadcastImage(broadcaster),
        });
      }
      return broadcastDetails.length ? broadcastDetails : [];
    },
  },
};
